import { render } from "./Project-3.vue?vue&type=template&id=04576888"
import script from "./Project-3.vue?vue&type=script&lang=js"
export * from "./Project-3.vue?vue&type=script&lang=js"
script.render = render

export default script